import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'includesId',
    pure: false
})
export class IncludesIdPipe implements PipeTransform {

    transform(array: any[], value: any): boolean {
        return array.some(it => (it.uniqueId && it.uniqueId == value.uniqueId) || (!it.uniqueId && it.id == value.id));
    }

}
